import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive, onMounted, computed,watch } from 'vue';
import { ElMessage } from 'element-plus';
import $http from '../http/index';
import $helper from '../helper/helper';

// 入参

export default /*#__PURE__*/_defineComponent({
  __name: 'NewProductCondition',
  props: {
    newProductTime: null
  },
  emits: ['showNewProductSearchData','searching','searched'],
  setup(__props: any, { emit }) {

const props = __props as {
    newProductTime:string
};





class InitData {
    startTime=''
    endTime=''
}

const data = reactive(new InitData());

onMounted(()=>{
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = ("0" + (now.getMonth() + 1)).slice(-2); 
    const endTime = `${currentYear}-${currentMonth}-01`
    now.setMonth(now.getMonth() - 1);
    const startTime = `${now.getFullYear()}-${("0" + (now.getMonth() + 1)).slice(-2)}-01`
    data.startTime=startTime;
    data.endTime=endTime;
})

/**
 * 通过监听newProductTime值，显示新品时间。
 */
watch(()=>props.newProductTime,()=>{
    if(!props.newProductTime){
        data.startTime='';
        data.endTime='';
        return;
    }
    var times = props.newProductTime.split('|');
    if(times.length>0){
        data.startTime=times[0];
    }
    if(times.length>1){
        data.endTime=times[1];
    }
})

/**
 * 查询操作
 */
const search = () =>{
    $http({
    url: "/API/Product/GetNewProducts",
    method: "POST",
    data: {
        startTime: data.startTime,
        endTime: data.endTime
    }
    }).then(res => {
        if(res.data.length<1){
            ElMessage({
                message: $helper.lan('暂无数据提供'),
                type: 'warning',
            })
        }
        for(let i=0;i<res.data.length;i++){
            res.data[i].MapCode = ''
        }
        emit("showNewProductSearchData",JSON.stringify(res.data))
        emit("searched")
    })
}


return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, {
        span: 24,
        style: {"padding-left":"5px","padding-bottom":"5px","padding-top":"8px"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref($helper).lan('新产品系列（每月），请选择时间：')) + " ", 1),
          _createVNode(_component_el_date_picker, {
            modelValue: data.startTime,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.startTime) = $event)),
            type: "month",
            format: "YYYY-MM",
            "value-format": "YYYY-MM-01",
            style: {"width":"100px"}
          }, null, 8, ["modelValue"]),
          _createTextVNode("- "),
          _createVNode(_component_el_date_picker, {
            modelValue: data.endTime,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.endTime) = $event)),
            type: "month",
            format: "YYYY-MM",
            "value-format": "YYYY-MM-01",
            style: {"width":"100px"}
          }, null, 8, ["modelValue"]),
          _createTextVNode("   "),
          _createVNode(_component_el_link, {
            underline: false,
            onClick: search
          }, {
            default: _withCtx(() => [
              _createElementVNode("h3", null, _toDisplayString(_unref($helper).lan('查询')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})